import React, {Component} from 'react';
import {Button, Modal, Form, Grid} from 'semantic-ui-react';

import MemberData from "../../data/MemberData";
import Toast from "../extras/Toast";

class MemberChangePassword extends Component {

    constructor() {
        super();

        this.state = {
            open: false,
            new_password: '',
            re_password: '',
            new_password_error: false,
            re_password_error: false,
            user:{full_name:''},
            id: null
        };

        this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this);
        this.handleRePasswordChange = this.handleRePasswordChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
    }

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.new_password === '') {
            this.setState({new_password_error: true});
        } else if (this.state.re_password === '') {
            this.setState({re_password_error: true});
        } else if (this.state.re_password !== this.state.new_password ) {
            this.refs.toast.show({message: 'Las contraseñas no coinciden!', type: 'error'});
        }else {
            this.setState({disabled_button: true});
            MemberData.password({password:this.state.new_password, id:this.state.id}, (res) => {
                if (res.update) {
                    this.refs.toast.show({message: res.message, type: 'success'});

                } else {
                    this.refs.toast.show({message: res.message, type: 'error'});
                }
                this.setState({disabled_button: false, open: false});
            });

        }
    }

    handleNewPasswordChange(event) {
        this.setState({new_password:event.target.value});
        if (event.target.value.trim() === '') {
            this.setState({new_password_error: true});
        } else {
            this.setState({new_password_error: false});
        }
    };

    handleRePasswordChange(event) {
        this.setState({re_password:event.target.value});
        if (event.target.value.trim() === '') {
            this.setState({re_password_error: true});
        } else {
            this.setState({re_password_error: false});
        }
    };

    handleOpen(user, id) {
        this.setState({
            id,
            user,
            open: true,
            new_password:'',
            re_password: '',
            new_password_error: false,
            re_password_error: false
        });
    };

    handleClose = () => {
        this.setState({open: false});
    };

    render() {
        return (
            <div>
              <Modal size='tiny' dimmer='inverted' open={this.state.open} onClose={this.handleClose}>
                <Modal.Header>{`Cambiar Contraseña - ${this.state.user.full_name}`}</Modal.Header>
                <Modal.Content>
                  <Modal.Description>
                    <Form onSubmit={this.handleSubmit}>
                      <Grid divided>
                        <Grid.Row>
                          <Grid.Column>
                            <Form.Field>
                              <Form.Input type='password' label='Nueva Contraseña' placeholder='Nueva Contraseña' value={this.state.new_password} onChange={this.handleNewPasswordChange} error={this.state.new_password_error}/>
                            </Form.Field>
                            <Form.Field>
                              <Form.Input type='password' label='Repetir Contraseña' placeholder='Repetir Contraseña' value={this.state.re_password} onChange={this.handleRePasswordChange} error={this.state.re_password_error}/>
                            </Form.Field>
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </Form>
                  </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                  <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                  <Button primary icon='save' loading={this.state.disabled_button} labelPosition='left' onClick={this.handleSubmit} content='Actualizar Contraseña'/>
                </Modal.Actions>
              </Modal>
                <Toast ref='toast'/>
            </div>
        );
    }
}

export default MemberChangePassword;



// WEBPACK FOOTER //
// ./src/components/security/MemberChangePassword.js